import type { ComponentChildren } from 'preact';
import { Header } from './Header';

/**
 * Page chrome for the web app: the `.bcapp` token scope + sticky Header +
 * a centered main column. Wrap every user-facing page in this so the
 * marketing/admin/partner pages keep their own palette.
 */
export function AppLayout({
  children,
  wide = false,
}: {
  children: ComponentChildren;
  wide?: boolean;
}) {
  return (
    <div class="bcapp">
      <Header />
      <main class={`bcapp-main${wide ? ' bcapp-main--wide' : ''}`}>{children}</main>
    </div>
  );
}
